<template>
  <transition name="notice">
    <div class="seelater-notice-base" v-show="showNotice">
      <div class="notice-wrap">
        <icon-base
          name="SeeLaterIcon"
          color="#FFF"
          width="20"
          height="20"
          :is-button="false"
          :is-fill="true"/>
        <span><span class="mess">{{ message }}</span></span>
      </div>
    </div>
  </transition>
</template>

<script>
import * as type from '@/utvStore/store/mutation-types'
import { mapState } from 'vuex'
import { DIALOG_STAT } from '@/CONSTS'
import IconBase from '@/utvStore/components/common/icon/IconBase'

export default {
  name: 'SeeLaterNotice',
  components: {
    IconBase
  },
  data() {
    return {
      showNotice: false,
      message: '「あとで見る」に追加しました',
      interval: 5000,
      tmid: 0,
    }
  },
  computed: {
    ...mapState({
      seelaterInfoStat: states => states.dialogs.seelaterInfoStat
    })
  },
  watch: {
    seelaterInfoStat(val){
      if(val === DIALOG_STAT.show) {
        clearTimeout(this.tmid)
        this.showNotice = true
        this.$store.dispatch(type.NOTIFY_SEELATER_ADDED, DIALOG_STAT.disable)
        this.tmid = setTimeout(this.closeNotice, this.interval)
      }
    }
  },
  methods: {
    closeNotice() {
      clearTimeout(this.tmid)
      this.showNotice = false
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";
.seelater-notice-base {
  width: 100%;
  height: 70px;
  background: linear-gradient(65.54deg, $col_temp_key1 21.4%, $col_temp_key2 76.64%);
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 90004;
  font-size: 14px;
  color: $col_white;
  .notice-wrap {
    width: 100%;
    height: 100%;
    max-width: 580px;
    margin: auto;
    display: flex;
    align-items: center;
    padding: 8px 20px;
    .mess {
      margin-left: 5px;
    }
  }
}

.notice-enter-active,
.notice-leave-active {
  transition: all 500ms ease-out 0s;
}
.notice-enter, .notice-leave-to {
  opacity: 0;
  transform: translate(0, 60px);
}
.notice-enter-to, .notice-leave {
  opacity: 1;
  transform: translate(0, 0);
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/SeeLaterNotice.vue